import React, {useState} from 'react'
import {Flex, ChatBubble, Div, MarkdownDisplay} from '/app/src/component'
import style from './style.css'

const PreviewStyle = {
    overflow: 'hidden',
    borderRadius: '60px',
    height: '84px',
    width: '100%',
    vAlignContent: 'center',
    userSelect: 'none',
    border: '3px solid transparent',
    cursor: 'pointer',
    margin: '2px 0px'
}

const PreviewStatusStyle = {
    padding: '0 10px',
    position: 'relative',
    center: true,
    basis: '80px',
}

const AvatarImageStyle = (isOnline)=>({style: {
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    border: isOnline?'3px solid #8FEF54':'3px solid #898989',
}})

export default function ({
    room, currentRoom,  title, imageUrl, entryBody,
    entryDateCreated, isOnline, isTyping, unread, children, send,
    exchange
}) {

    const active = currentRoom === room
    imageUrl = imageUrl || '/images/customer_icon_noborder.png'

    const [screen, setScreen] = useState('normal')

    var indexOfLastSpace = -1
    var dateTimeFormatted = ''
    if(entryDateCreated){
        indexOfLastSpace = entryDateCreated.lastIndexOf(" ")
        dateTimeFormatted =  entryDateCreated.substr(0, indexOfLastSpace) + "\n"+ entryDateCreated.substr(indexOfLastSpace + 1);
    }

    const _renderActiveButton = ()=>{
        //IF there are no children
        if(!children) return null;
        let quick = screen === 'quick'
        let buttonStyle={}
        let QuickButtonSrc= '/images/QuickButtonGrey.png';
        if(quick){
            buttonStyle={
                width: '25vw',
            }
            QuickButtonSrc= '/images/QuickButtonBlue.png';
        }
        return (
            <div>
                <div className={style.ActiveButton} style={buttonStyle}>
                     {quick && (
                         <Flex height='100%' width='100%' center backgroundColor='black'>
                            {children}
                        </Flex>
                     )}
                </div>
                <Flex vAlignContent='center' className={style.ArrowWrapper}>
                    <img src={QuickButtonSrc} alt='open'/>
                </Flex>
            </div>
        )
    }

    const _renderExchange = ()=>{
        if (!exchange)
            return null
        return (
            <Flex className='ellipsis'
                fontSize='12px'
                color='MediumGray5'
            >
                {exchange.parent_label && (
                <React.Fragment>
                    <Div className='ellipsis'>{exchange.parent_label} </Div>
                    <Div margin='0 5px'> > </Div>
                </React.Fragment>
                )}
                <Flex shrink={0} className='ellipsis'>{exchange.label}</Flex>
            </Flex>
        )
    }
    const _quickButtonOnClick = ()=>{
        if(screen === 'quick'){
             setScreen('normal')
        }else{
             setScreen('quick')
        }
    }

    return (
        <Flex {...PreviewStyle}
            border={active?'3px solid #2EA2D2':'3px solid transparent'}
            backgroundColor={active?'LightGray1':'white'}
            backgroundHover='LightGray1'>
            <Flex {...PreviewStatusStyle}>
                <img src={imageUrl} {...AvatarImageStyle(isOnline)} alt='avatar'/>
                <Flex className={style.IsTypingWrapper}>
                    {isTyping && <ChatBubble/>}
                </Flex>
            </Flex>

            <Flex grow column>
                {_renderExchange()}
                <Flex className={style.PreviewTitle} fontWeight={unread?500:300}>
                    {title}
                </Flex>
                <Flex fontWeight={unread?500:300} color='black' height='20px'>
                    <MarkdownDisplay text={entryBody} ellipsis/>
                </Flex>
            </Flex>

            <Flex className={style.previewExtra} basis='20%' column hAlignContent='center'>
                <Flex>
                    <img
                        src={send?'/images/Placeholder_Outgoing.png':'/images/Placeholder_Incoming.png'}
                        width='40'
                        height='40'
                        alt='extra'
                        display='block'
                    />
                </Flex>
                <Flex className={style.DateCreated} fontWeight={unread?500:300} overflow='visible'>
                    {dateTimeFormatted}
                </Flex>
            </Flex>
            <Flex basis='10%' className={style.ActiveButtonWrapper} onClick={_quickButtonOnClick}>
                {active && _renderActiveButton()}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/Conversation.js